export default "__VITE_ASSET__DC3XZmVL__"